import React, { useMemo, useState } from 'react';
import { FormGroup, Label, Input, Row, Col, Button } from 'reactstrap';
import { inputId, inputName, drawTooltipHelp } from '../../../helper/form';
import FieldError from '../../../helper/FieldError';

import Select from 'react-select';

const ComplianceActivityGroupSelect = (props) => {
  const {
    index,
    groups,
    configuration: {
      formName,
      groupName
    },
    callbacks: {
      onChangeActivityGroups: callbackOnChangeActivityGroups
    },
    helpers: {
      isOptionDisabled
    }
  } = props;

  const [activityGroup, setActivityGroup] = useState(props?.activityGroup || {});

  const onChangeActivityGroup = (event, key) => {
    let _activityGroup = { ...activityGroup };
    let value = event.target.value;

    if(event.target.type == 'checkbox'){
      value = event.target.checked;
    }

    _activityGroup[key] = value;

    setActivityGroup(_activityGroup)

    if(_.isFunction(callbackOnChangeActivityGroups)){
      callbackOnChangeActivityGroups(groupName, index, _activityGroup)
    }
  }

  const onDestroyActivityGroup = e => {
    swalWithBootstrap.fire({
      title: I18n.t('compliance.groups.destroy.confirm.title'),
      html: '<p>¿Estás seguro de eliminar el grupo?</p>',
    }).then( result => {
      if(result.isConfirmed){
        onChangeActivityGroup({
          target: { value: true },
        }, '_destroy')
      }
    })
  }

  const groupSelectOptions = useMemo(() => {
    return _.map(groups, group => {
      return {
        value: group.id,
        label: group.name
      };
    });
  }, []);

  const groupSelectedOption = useMemo(() => {
    return _.find(groupSelectOptions, { value: activityGroup?.compliance_group_id })
  }, [activityGroup?.compliance_group_id])

  return (
    <Row>
      <Col md={12}>
        <FormGroup>
          <FieldError errors={ activityGroup?.errors?.compliance_group_id || [] }>
            <Label for={ inputId(formName, 'compliance_group_id') } className='required'>
              { I18n.t("activerecord.models.compliance/group.one") }
            </Label>
            <Select
              isSearchable
              id={inputId(formName, 'compliance_group_id')}
              name={inputName(formName, 'compliance_group_id')}
              value={groupSelectedOption}
              onChange={e => onChangeActivityGroup({ target: { value: e?.value } }, 'compliance_group_id')}
              options={groupSelectOptions}
              invalid={_.has(activityGroup?.errors, 'compliance_group_id')}
              isOptionDisabled={option => isOptionDisabled(option)}
              placeholder={`-- Selecciona un ${I18n.t('activerecord.models.compliance/group.one')} --`}
            />
          </FieldError>
        </FormGroup>
        {
          groupName == 'reviewer_groups' && (
            <FormGroup>
              <div className='custom-switch'>
                  <Input
                    id={ inputId(formName, 'mandatory') }
                    type='checkbox'
                    className='custom-control-input'
                    name={ inputName(formName, 'mandatory') }
                    onChange={ e => onChangeActivityGroup(e, 'mandatory') }
                    checked={ activityGroup?.mandatory || false }
                  />
                  <Label for={ inputId(formName, 'mandatory') } className='custom-control-label'>
                    { I18n.t("activerecord.attributes.compliance/activity_group.mandatory") }
                  </Label>
                  { drawTooltipHelp(I18n.t('activerecord.help.compliance/reviewer_group.mandatory')) }
              </div>
            </FormGroup>
          )
        }
        <FormGroup className='text-end'>
          <Button
            color='danger'
            size='sm'
            onClick={ e => onDestroyActivityGroup(e) }
            outline
            title={ I18n.t('compliance.activities.form.remove_group') }
          >
            <i className="fas fa-trash"></i>
          </Button>
        </FormGroup>
      </Col>
    </Row>
  )
}

export default ComplianceActivityGroupSelect;